import { createSonarSelector } from '@lib/selectors';
import { UserReference } from '@sonar-software/sonar-core';
import { useSonarSelector } from '../useSonarSelector';

const mapSelector = createSonarSelector((state) => state.core.users.byIdMap);

const emptyMap: Record<number, UserReference> = {};
const empty: UserReference = {
	email: '',
	firstName: '',
	lastName: '',
	userId: 0
};

/**
 * Gets the shared sync {@link UserReference} for the provided user id.
 * @param userId Id of the user to lookup.
 * @returns The {@link UserReference} for the target user, or an empty object if none exists yet.
 */
export function useUserReference(userId: number): UserReference {
	return useSonarSelector((state) => (mapSelector(state).data ?? emptyMap)[ userId ] ?? empty);
}
